// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"127":"906ebc98","405":"b3b53ca6","532":"d35b0517"}[chunkId] + ".css";
};